import React from "react";

import withQuoteData from "../../../../../../hocs/withQuoteData";
import ActiveRiskRewardHelper from "../../../../../../lib/UniversalTable/RendererHelpers/ActiveRiskRewardHelper";
import universalTableStockIdExtractor from "../../../../../../lib/UniversalTable/universalTableStockIdExtractor";

const ActiveRiskReward = ({
  resultMetaData,
  format,
  quoteData,
  emptyQuoteData
}) => {
  if (emptyQuoteData) {
    return null;
  }

  const currentPrice =
    quoteData?.close !== null && typeof quoteData?.close !== "undefined"
      ? quoteData.close
      : null;

  return (
    <div className="number-renderer">
      {ActiveRiskRewardHelper.render(resultMetaData, currentPrice, format) ??
        "-"}
    </div>
  );
};

const ActiveRiskRewardWithQuote = withQuoteData(
  false,
  universalTableStockIdExtractor
)(ActiveRiskReward);

ActiveRiskRewardWithQuote.shouldRenderDash =
  ActiveRiskRewardHelper.shouldRenderDash;

export default ActiveRiskRewardWithQuote;
